import styled from 'styled-components';
import { changeRgbLuminance } from "../../utils/changeRgbLuminance";
import { getStateColor } from "../../utils/getStateColor";
export const Container = styled.div`
  cursor: ${_ref => {
  let {
    disabled
  } = _ref;
  return disabled && 'not-allowed';
}};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  opacity: ${_ref2 => {
  let {
    disabled
  } = _ref2;
  return disabled && '0.3';
}};
  width: 100%;
`;
export const Label = styled.label`
  ${_ref3 => {
  let {
    theme
  } = _ref3;
  return theme.fonts.labelMD;
}}
  cursor: ${_ref4 => {
  let {
    disabled
  } = _ref4;
  return disabled && 'not-allowed';
}};
  color: ${_ref5 => {
  let {
    theme
  } = _ref5;
  return theme?.colors?.neutralL5;
}};
  margin-bottom: 12px;
`;
export const InputContainer = styled.div`
  background-color: ${_ref6 => {
  let {
    theme
  } = _ref6;
  return theme.colors.secondary;
}};
  display: flex;
  align-items: center;
  padding: ${_ref7 => {
  let {
    size
  } = _ref7;
  return size === 'sm' ? '14px' : size === 'md' ? '17px 14px' : '25px 14px';
}};
  height: ${_ref8 => {
  let {
    size
  } = _ref8;
  return size === 'sm' ? '40px' : size === 'md' ? '48px' : '64px';
}};
  gap: 10px;
  cursor: ${_ref9 => {
  let {
    disabled
  } = _ref9;
  return disabled && 'not-allowed';
}};
  border-radius: 10px;
  outline: ${_ref10 => {
  let {
    theme,
    isFocused
  } = _ref10;
  return isFocused && `1px solid ${theme.colors.secondaryL3}`;
}};

  &:hover {
    background-color: ${_ref11 => {
  let {
    theme,
    disabled
  } = _ref11;
  return !disabled && getStateColor(theme.colors.secondary, 'hover');
}};
  }

  &:hover input:not(:disabled) {
    background-color: ${_ref12 => {
  let {
    theme
  } = _ref12;
  return getStateColor(theme.colors.secondary, 'hover');
}};
  }

`;
export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const ClearButton = styled.div`
  align-items: center;
  background-color: ${_ref13 => {
  let {
    theme
  } = _ref13;
  return theme.colors.secondaryL1;
}};
  background-color: transparent;
  border-radius: 50%;
  border: 0;
  cursor: ${_ref14 => {
  let {
    disabled
  } = _ref14;
  return disabled ? 'not-allowed' : 'pointer';
}};
  display: flex;
  justify-content: center;
  min-height: ${_ref15 => {
  let {
    size
  } = _ref15;
  return size === 'sm' ? '28px' : '32px';
}};
  min-width: ${_ref16 => {
  let {
    size
  } = _ref16;
  return size === 'sm' ? '28px' : '32px';
}};
  outline: none;

  &:not(:disabled):hover {
    background-color: ${_ref17 => {
  let {
    theme
  } = _ref17;
  return changeRgbLuminance(theme.colors.secondaryL1, 2.5);
}};
  }

  &:not(:disabled):active {
    background-color: ${_ref18 => {
  let {
    theme
  } = _ref18;
  return changeRgbLuminance(theme.colors.secondaryL1, 5);
}};
  }
`;
export const DropdownPositioner = styled.div`
  position: relative;
`;
export const ChildrenContainer = styled.div`
  background-color: ${_ref19 => {
  let {
    theme
  } = _ref19;
  return theme.colors.secondary;
}};
  border-radius: 10px;
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
  display: ${_ref20 => {
  let {
    open
  } = _ref20;
  return open ? 'flex' : 'none';
}};
  flex-direction: column;
  max-height: ${_ref21 => {
  let {
    maxHeight
  } = _ref21;
  return maxHeight;
}}px;
  overflow-y: auto;
  position: absolute;
  top: 8px;
  width: 100%;

  ::-webkit-scrollbar {
    width: 6px;
  }
  
  ::-webkit-scrollbar-track {
    border-radius: 10px;
  }
  
  ::-webkit-scrollbar-thumb {
    background: ${_ref22 => {
  let {
    theme
  } = _ref22;
  return theme?.colors?.secondaryL2;
}};
    border-radius: 10px;
  }

  & > div {
    :first-child {
      border-radius: 10px 10px 0 0;
    }

    :last-child {
      border-radius: 0 0 10px 10px;
    }
  }
`;
export const Input = styled.input`
  ${_ref23 => {
  let {
    theme
  } = _ref23;
  return theme.fonts.infoLG;
}}
  border: none;
  background-color: ${_ref24 => {
  let {
    theme
  } = _ref24;
  return theme.colors.secondary;
}};
  flex: 1;
  color: ${_ref25 => {
  let {
    theme
  } = _ref25;
  return theme.colors.neutralL5;
}};
  cursor: ${_ref26 => {
  let {
    disabled
  } = _ref26;
  return disabled && 'not-allowed';
}};

  ::placeholder {
    ${_ref27 => {
  let {
    theme
  } = _ref27;
  return theme.fonts.infoMD;
}}
    color: ${_ref28 => {
  let {
    theme
  } = _ref28;
  return theme.colors.secondaryL2;
}};
  }

  &:focus  {
    outline: none;
  }
`;
export const HelpMessage = styled.div`
  ${_ref29 => {
  let {
    theme
  } = _ref29;
  return theme.fonts.textMD;
}}
  color: ${_ref30 => {
  let {
    theme,
    error
  } = _ref30;
  return error ? theme.colors.error : theme.colors.neutralL5;
}};
  margin: 0;
  margin-top: 4px;
  height: 18px;
`;
export const Gutter = styled.div``;